import type { ApiError } from '@/types'

const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8000'
const USE_MOCKS = import.meta.env.VITE_USE_MOCKS === 'true'

export { USE_MOCKS }

function getToken(): string | null {
  return localStorage.getItem('auth_token')
}

function removeToken(): void {
  localStorage.removeItem('auth_token')
}

function dispatchUnauthenticated(): void {
  window.dispatchEvent(new Event('auth:unauthenticated'))
}

export async function apiRequest<T>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const token = getToken()
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string>),
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  const url = `${BASE_URL}${path}`
  const res = await fetch(url, { ...options, headers })

  if (res.status === 401) {
    removeToken()
    dispatchUnauthenticated()
    const err: ApiError = { status: 401, message: 'Unauthorized' }
    throw err
  }

  if (!res.ok) {
    let message = `HTTP ${res.status}`
    try {
      const body = await res.json()
      if (body?.detail) {
        message = typeof body.detail === 'string'
          ? body.detail
          : JSON.stringify(body.detail)
      }
    } catch {
      // ignore parse error
    }
    const err: ApiError = { status: res.status, message }
    throw err
  }

  // 204 No Content
  if (res.status === 204) {
    return undefined as unknown as T
  }

  return res.json() as Promise<T>
}
